<template>
    <div>
        <Breadcrumb section-name="Operations" :breadcrumb="breadCrumb" :btn-name="'Add '+ breadCrumb"
                    :click-action="openModal"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <Table :tbl-data="table" :param="param"></Table>
                </div>
            </div>
        </div>
        <div class="modal fade" id="add" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-capitalize">{{actionType}} Slot</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form @submit.prevent="actionType == 'add' ? add() : edit()">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6 form-group mb-3">
                                    <label class="form-label">Project Name<span class="text-danger">*</span></label>
                                    <select class="form-select" v-model="addEditParam.project_id" name="project_id">
                                        <option value="">Select Project</option>
                                        <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
                                    </select>
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="col-md-6 form-group mb-3">
                                    <label class="form-label">Slot Name<span class="text-danger">*</span></label>
                                    <select class="form-select" v-model="addEditParam.slot_id" name="slot_id">
                                        <option value="">Select Slot</option>
                                        <option v-for="slot in slots" :key="slot.id" :value="slot.id">{{ slot.name }}</option>
                                    </select>
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="col-md-6 form-group mb-3">
                                    <label class="form-label">Start Date<span class="text-danger">*</span></label>
                                    <flat-pickr class="form-control" v-model="addEditParam.start_date" name="start_date"
                                                placeholder="Start Date"
                                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="col-md-6 form-group mb-3">
                                    <label class="form-label">End Date<span class="text-danger">*</span></label>
                                    <flat-pickr class="form-control" v-model="addEditParam.end_date" name="end_date"
                                                placeholder="End Date"
                                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="col-md-6 form-group mb-3">
                                    <label class="form-label">Slot Amount<span class="text-danger">*</span></label>
                                    <input type="text" v-model="addEditParam.amount" name="amount" class="form-control"
                                           placeholder="Slot Amount">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="col-md-6 form-group mb-3">
                                    <label class="form-label">Remarks</label>
                                    <input type="text" v-model="addEditParam.remarks" name="remarks" class="form-control"
                                           placeholder="Remarks">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary btn-width" data-bs-dismiss="modal">Close
                            </button>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">{{actionType == 'add' ? 'Save' : 'Update'}}</button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table.vue";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue.vue";

export default {
    components: {Table, Breadcrumb, ConfirmDialogue},
    data() {
        return {
            breadCrumb: ['Add Slot'],
            loading: false,
            projects: [],
            slots: [],
            addEditParam: {
                project_id: '',
                slot_id: '',
                start_date: '',
                end_date: '',
                amount: '',
                remarks: '',
            },
            param: {
                keyword: '',
                limit: 15,
                order_by: 'id',
                order_mode: 'DESC',
                page: 1,
            },
            actionType: 'Add',
            id: [],
            table: {
                alignTop: false,
                columns: [
                    {type: 'text', key: 'project_name', label: 'Project Name', sortable: true},
                    {type: 'text', key: 'slot_name', label: 'Slot Name', sortable: true},
                    {type: 'text', key: 'from_date', label: 'From Date', sortable: false},
                    {type: 'text', key: 'to_date', label: 'To Date', sortable: false},
                    {type: 'text', key: 'amount', label: 'Slot Amount', sortable: true},
                    {type: 'text', key: 'remarks', label: 'Remarks', sortable: true},
                ],
                rows: [],
                row_actions: [
                    {name: 'edit', type: 'action', label: 'bx bx-pencil', color: 'btn-info'},
                    {name: 'delete', type: 'action', label: 'bx bx-trash', color: 'btn-gradient-danger'}
                ],
                tableIconAction: (data) => {
                    this.openModal(data.row_action, data.row_data);
                },
                tableLoading: false,
                paginateData: {},
                updatePagination: (page) => {
                    this.list(page)
                },
                updateFilter: (param) => {
                    this.param = param
                    this.list()
                },
                download: [],
                noDataError: ' Please click "+ Add Slot" to add a new Slot'
            }
        }
    },
    methods: {
        openModal(type, data = null) {
            this.clearForm(type)
            this.id = this.structureReturnData(data)
            if (type === 'add' || type === 'edit') {
                $('#add').modal('show');
            }
            if (type === 'edit') {
                this.single()
            } else if (type === 'delete') {
                this.deleteModal()
            }
        },
        clearForm: function (type) {
            ApiService.ClearErrorHandler();
            this.actionType = type
            this.addEditParam = {
                project_id: '',
                slot_id: '',
                start_date: '',
                end_date: '',
                amount: '',
                remarks: '',
            }
        },
        async deleteModal() {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Are you sure you want to delete this Slot?',
                okButton: 'Delete',
            })
            if (ok) {
                this.delete()
            }
        },
        add: function () {
            ApiService.ClearErrorHandler();
            this.loading = true;
            ApiService.POST(ApiRoutes.ProjectSlot + '/save', this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    $('#add').modal('hide');
                    this.$toast.success(res.message)
                    this.list()
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        edit: function () {
            ApiService.ClearErrorHandler();
            this.loading = true;
            ApiService.POST(ApiRoutes.ProjectSlot + '/update', this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    $('#add').modal('hide');
                    this.list()
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        delete: function () {
            ApiService.POST(ApiRoutes.ProjectSlot + '/delete', {id: this.id[0]}, (res) => {
                this.$refs.confirmDialogue._loading(false)
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    this.$refs.confirmDialogue._hide()
                    this.list()
                }
            });
        },
        single: function () {
            ApiService.POST(ApiRoutes.ProjectSlot + '/single', {id: this.id[0]}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam = res.data
                }
            });
        },
        list: function (page) {
            if (page == undefined) {
                page = 1
            }
            this.param.page = page;
            this.table.loading = true
            ApiService.POST(ApiRoutes.ProjectSlot + '/list', this.param, (res) => {
                this.table.loading = false
                if (parseInt(res.status) === 200) {
                    this.table.rows = res.data.data
                    this.table.paginateData = res.data
                }
            });
        },
        fetchProjects: function () {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 5000, page: 1}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data
                }
            });
        },
        fetchSlots: function () {
            ApiService.POST(ApiRoutes.ListSlot, {limit: 5000, page: 1}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.slots = res.data.data
                }
            });
        }
    },
    mounted() {
        this.list()
        this.fetchProjects()
        this.fetchSlots()
    }
}
</script>
